<template>
  <c-dialog
    :value="visible"
    width="800"
    close-key="cove.general.close"
    title-key="popup.filingFees.title"
    @input="close">

    <div v-if="visible">
      <v-data-table
        :items="docketEntryFeeMaps"
        :headers="headers"
        item-key="resourceID"
        disable-sort
        disable-pagination
        hide-default-footer
        :mobile-breakpoint="800">
        <template #item.docketEntry.lead="{ value }">
          <template v-if="value">
            <v-icon>
              mdi-check
            </v-icon>
            <span class="d-sr-only">
              {{ $t('global.yes') }}
            </span>
          </template>
          <template v-else>
            <span class="d-sr-only">
              {{ $t('global.no') }}
            </span>
          </template>
        </template>
        <template #item.feeAmount="{ value }">
          {{ value | formatCurrency }}
        </template>
        <template #item.filedOnBehalfOfs="{ value }">
          <div v-for="fobo in value" :key="fobo.resourceID">
            {{ getFiledByName(fobo) }}
          </div>
        </template>
      </v-data-table>
    </div>
  </c-dialog>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import Filing from '@/application/filing';

export default {
  // either filingID (UUID) or docketEntryID (UUID) must be supplied as this popup can render in either mode
  props: {
    value: {
      type: Boolean
    },
    filingID: {
      type: String
    },
    docketEntryID: {
      type: String
    }
  },
  data () {
    return {
      loading: false,
      docketEntryFeeMaps: []
    };
  },
  computed: {
    visible () {
      return this.value && !this.loading;
    },
    headers () {
      let headers = [];

      if (!_.isNil(this.filingID))
      {
        headers.push({ text: this.$t('docketEntry.lead'), value: 'docketEntry.lead', sortable: false });
        headers.push({ text: this.$t('popup.filingFees.column.docketEntry'), value: 'docketEntry.docketEntryExternalName',
          sortable: false });
      }

      headers.push({ text: this.$t('popup.filingFees.column.fee'), value: 'feeName', sortable: false });
      headers.push({ text: this.$t('popup.filingFees.column.responsibleParty'), value: 'filedOnBehalfOfs', sortable: false });
      headers.push({ text: this.$t('popup.filingFees.column.feeAmount'), value: 'feeAmount', sortable: false });

      return headers;
    }
  },
  watch: {
    value (newValue) {
      if (newValue)
      {
        this.$cove.block();
        this.loading = true;
        this.loadDocketEntryFeeMaps()
          .finally(() => {
            this.loading = false;
            this.$cove.unblock();
          });
      }
      else
      {
        this.someData = null;
      }
    }
  },
  methods: {
    loadDocketEntryFeeMaps () {
      let query = {
        sort: ['docketEntry.lead,desc', 'docketEntry.docketEntryExternalName,desc', 'feeName,asc'],
        size: this.CONST.PAGING_MAX_SIZE,
        fields: '*,docketEntry(*),filedOnBehalfOfs(*,existingCaseParty(*),caseParty(*,actor(*)))'
      };

      if (!_.isNil(this.filingID))
      {
        query.filingID = this.filingID;
      }
      else if (!_.isNil(this.docketEntryID))
      {
        query.docketEntryID = this.docketEntryID;
      }

      let url = this.$cove.getAPI({ name: 'api.docketEntryFeeMaps', query });
      return axios.get(url)
        .then((response) => {
          this.docketEntryFeeMaps = _.get(response, 'data._embedded.results', []);
        });
    },
    getFiledByName (filedOnBehalfOf) {
      return Filing.getFiledOnBehalfOfName(filedOnBehalfOf);
    },
    close () {
      this.$emit('input', false);
    }
  }
};
</script>